import {ApiService} from "./Http";

export default class AuthApi extends ApiService {
}
